// extracted by mini-css-extract-plugin
export default {"footerLinkItem":"footerLink_footerLinkItem__TLq1F","footerLink":"footerLink_footerLink__3a27Z"};